module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_c('i', {
    staticClass: "far fa-cog m-r-sm"
  }), _vm._v(" Xero Settings")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-240254f2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/system/XeroHeading.vue
// module id = 956
// module chunks = 0